import store from '../store/store'
// import pattern from 'patternomaly'
function getAllIndexes (arr, val) {
    var indexes = []; var i = -1
    while ((i = arr.indexOf(val, i + 1)) !== -1) {
        indexes.push(i)
    }
    return indexes
}

export const dataConvertDict = {
    'salesvsbudget': (data) => {
        const y1 = data['Budget revenue']
        const y2 = data['Actual revenue']
        store.commit('budget/SET_BUDGET_GRAPH_SCORE', { title: 'salesvsbudget', value: (1 - (((y1.reduce((a, b) => a + b, 0) / y2.reduce((a, b) => a + b, 0))) - 1) * 100).toFixed(2) })
        return {
            labels: data['x_label'],
            data: [{ label: 'Budget revenue', data: y1, radius: 2, yAxisID: 'A', type: 'line', fill: 'false' }, { label: 'Actual revenue', data: y2, radius: 0, yAxisID: 'A', type: 'bar' }],
            scales: { 'yAxes': [{ stacked: false, label: 'Sales revenue', id: 'A', position: 'left' }], 'xAxes': { stacked: false, label: '' } },
            type: 'bar'
        }
    },
    'kpuctr': (data) => {
        const y1 = data['KPU']
        const y2 = data['CTR']
        return {
            labels: data['x_label'],
            data: [{ label: 'KPU', data: y1, radius: 2, yAxisID: 'B', type: 'line', fill: 'false' }, { label: 'Cost to revenue', data: y2, radius: 2, yAxisID: 'A', type: 'line' }],
            scales: { 'yAxes': [{ stacked: false, label: 'Cost to revenue %', id: 'A', position: 'left' }, { stacked: false, label: 'KPU', id: 'B', position: 'right' }], 'xAxes': { stacked: false, label: '' } },
            type: 'line'
        }
    },
    'hoursvsbudget': (data) => {
        const y1 = data['Actual hours']
        const y2 = data['Budget hours']
        store.commit('budget/SET_BUDGET_GRAPH_SCORE', { title: 'hoursvsbudget', value: ((((y1.reduce((a, b) => a + b, 0) / y2.reduce((a, b) => a + b, 0))) - 1) * 100).toFixed(2) })
        return {
            labels: data['x_label'],
            data: [{ label: 'Budget hours', data: y2, radius: 2, yAxisID: 'A', type: 'line', fill: 'false' }, { label: 'Worked hours', data: y1, radius: 2, yAxisID: 'A', type: 'bar' }],
            scales: { 'yAxes': [{ stacked: false, label: 'Hours', id: 'A', position: 'left' }], 'xAxes': { stacked: false, label: '' } },
            type: 'bar'
        }
    },
    'hourdistribution': (data) => {
        let dataDict = {}
        for (let func of Array.from(new Set(data.employee_function))) {
            dataDict[func] = []
        }
        for (let i in data['Hours share (perc.)']) {
            dataDict[data['employee_function'][i]].push(data['Hours share (perc.)'][i])
        }
        let returnData = []
        for (let item in dataDict) {
            let obj = {}
            obj.label = item
            obj.data = dataDict[item]
            obj.yAxisID = 'A'
            obj.type = 'bar'
            returnData.push(obj)
        }

        return {
            labels: Array.from(new Set(data['x_label'])),
            data: returnData,
            scales: { 'yAxes': [{ stacked: true, label: 'Percentage', id: 'A', position: 'left' }], 'xAxes': { stacked: true, label: '' } },
            type: 'bar'
        }
    },
    'hourdistribution_peers': (data) => {
        let xLabels = Object.keys(data)
        let idx = xLabels.indexOf('employee_function')
        xLabels.splice(idx, 1)
        let dataDict = {}
        for (let func of Array.from(new Set(data.employee_function))) {
            dataDict[func] = []
        }
        for (let dataset in xLabels) {
            for (let i = 0; i < data[xLabels[0]].length; i++) {
                dataDict[data['employee_function'][i]].push(data[xLabels[dataset]][i])
            }
        }
        let returnData = []
        for (let item in dataDict) {
            let obj = {}
            obj.label = item
            obj.data = dataDict[item]
            obj.yAxisID = 'A'
            obj.type = 'bar'
            returnData.push(obj)
        }

        return {
            labels: Array.from(new Set(xLabels)),
            data: returnData,
            scales: { 'yAxes': [{ stacked: true, label: 'Percentage', id: 'A', position: 'left' }], 'xAxes': { stacked: true, label: '' } },
            type: 'bar'
        }
    },
    'workexperience': (data) => {
        let dataDict = {}
        for (let func of Array.from(new Set(data.employee_function))) {
            dataDict[func] = []
        }
        for (let i in data['Work experience (months)']) {
            dataDict[data['employee_function'][i]].push(data['Work experience (months)'][i])
        }
        let returnData = []
        for (let item in dataDict) {
            let obj = {}
            obj.label = item
            obj.data = dataDict[item]
            obj.yAxisID = 'A'
            obj.type = 'line'
            obj.fill = false
            obj.radius = 2
            returnData.push(obj)
        }
        return {
            labels: Array.from(new Set(data['x_label'])),
            data: returnData,
            scales: { 'yAxes': [{ stacked: false, label: 'Work experience (months)', id: 'A', position: 'left' }], 'xAxes': { stacked: false, label: '' } },
            type: 'line'
        }
    },
    'workexperience_peers': (data) => {
        let datasets = Object.keys(data)
        let idx = datasets.indexOf('employee_function')
        datasets.splice(idx, 1)

        let dataDict = {}
        for (let d in datasets) {
            dataDict[datasets[d]] = data[datasets[d]]
        }

        let returnData = []
        for (let item in dataDict) {
            let obj = {}
            obj.label = item
            obj.data = dataDict[item]
            returnData.push(obj)
        }

        return {
            labels: Array.from(new Set(data.employee_function)),
            data: returnData,
            scales: { 'yAxes': [{ stacked: false, label: 'Work experience (months)', id: 'A', position: 'left' }], 'xAxes': { stacked: false, label: '' } },
            type: 'bar'
        }
    },
    'age': (data) => {
        let dataDict = {}
        for (let func of Array.from(new Set(data.employee_function))) {
            dataDict[func] = []
        }
        for (let i in data['Age (years)']) {
            dataDict[data['employee_function'][i]].push(data['Age (years)'][i])
        }
        let returnData = []
        for (let item in dataDict) {
            let obj = {}
            obj.label = item
            obj.data = dataDict[item]
            obj.yAxisID = 'A'
            obj.type = 'line'
            obj.fill = false
            obj.radius = 2
            returnData.push(obj)
        }
        return {
            labels: Array.from(new Set(data['x_label'])),
            data: returnData,
            scales: { 'yAxes': [{ stacked: false, label: 'Age (years)', id: 'A', position: 'left', 'min': 16 }], 'xAxes': { stacked: false, label: '' } },
            type: 'line'
        }
    },
    'age_peers': (data) => {
        let datasets = Object.keys(data)
        let idx = datasets.indexOf('employee_function')
        datasets.splice(idx, 1)

        let dataDict = {}
        for (let d in datasets) {
            dataDict[datasets[d]] = data[datasets[d]]
        }

        let returnData = []
        for (let item in dataDict) {
            let obj = {}
            obj.label = item
            obj.data = dataDict[item]
            returnData.push(obj)
        }

        return {
            labels: Array.from(new Set(data.employee_function)),
            data: returnData,
            scales: { 'yAxes': [{ stacked: false, label: 'Age (years)', id: 'A', position: 'left', 'min': 16 }], 'xAxes': { stacked: false, label: '' } },
            type: 'bar'
        }
    },
    'hourlyrate': (data) => {
        let dataDict = {}
        for (let func of Array.from(new Set(data.employee_function))) {
            dataDict[func] = []
        }
        for (let i in data['Hourly rate (euros)']) {
            dataDict[data['employee_function'][i]].push(data['Hourly rate (euros)'][i])
        }
        let returnData = []
        for (let item in dataDict) {
            let obj = {}
            obj.label = item
            obj.data = dataDict[item]
            obj.yAxisID = 'A'
            obj.type = 'line'
            obj.fill = false
            obj.radius = 2
            returnData.push(obj)
        }
        return {
            labels: Array.from(new Set(data['x_label'])),
            data: returnData,
            scales: { 'yAxes': [{ stacked: false, label: 'Hourly rate (€)', id: 'A', position: 'left', 'min': 5 }], 'xAxes': { stacked: false, label: '' } },
            type: 'line'
        }
    },
    'hourlyrate_peers': (data) => {
        let datasets = Object.keys(data)
        let idx = datasets.indexOf('employee_function')
        datasets.splice(idx, 1)

        let dataDict = {}
        for (let d in datasets) {
            dataDict[datasets[d]] = data[datasets[d]]
        }

        let returnData = []
        for (let item in dataDict) {
            let obj = {}
            obj.label = item
            obj.data = dataDict[item]
            returnData.push(obj)
        }

        return {
            labels: Array.from(new Set(data.employee_function)),
            data: returnData,
            scales: { 'yAxes': [{ stacked: false, label: 'Hourly rate (€)', id: 'A', position: 'left', 'min': 5 }], 'xAxes': { stacked: false, label: '' } },
            type: 'bar'
        }
    },
    'employeehours': (data, type) => {
        let yLabels = { 'AOV': 'Average order value (€)', 'Conv': 'Conversion percentage', 'ROI': 'Revenue divided by employee cost', 'Prod': 'Productivity per hour (€)' }
        // eslint-disable-next-line
        let sum = data[type].reduce((previous, current) => current += previous)
        let avg = Math.round(sum / data[type].length)
        let avgArray = []
        for (let i = 0; i < data[type].length; i++) {
            avgArray.push(avg)
        }
        const y1 = data[type]
        return {
            labels: data['x_label'],
            data: [{ label: type, data: y1, radius: 2, yAxisID: 'A', type: 'line', fill: 'false' }, { label: 'Average', data: avgArray, radius: 0, yAxisID: 'A', type: 'line', fill: 'false', backgroundColor: '#A9A9A9', borderColor: '#A9A9A9', borderDash: [2, 5] }],
            scales: { 'yAxes': [{ stacked: false, label: yLabels[type], id: 'A', position: 'left' }], 'xAxes': { stacked: false, label: '' } },
            type: 'line'
        }
    },
    'productivitystoredetail': (data, type) => {
        let yLabels = { 'AOV': 'Average order value (€)', 'Conv': 'Conversion percentage', 'ROI': 'Revenue divided by employee cost', 'Prod': 'Productivity per hour (€)' }
        // eslint-disable-next-line
        let sum = data[type].reduce((previous, current) => current += previous)
        let avg = Math.round(sum / data[type].length)
        let avgArray = []
        for (let i = 0; i < data[type].length; i++) {
            avgArray.push(avg)
        }
        const y1 = data[type]
        return {
            labels: data['x_label'],
            data: [{ label: type, data: y1, radius: 2, yAxisID: 'A', type: 'line', fill: 'false' }, { label: 'Average', data: avgArray, radius: 0, yAxisID: 'A', type: 'line', fill: 'false', backgroundColor: '#A9A9A9', borderColor: '#A9A9A9', borderDash: [2, 5] }],
            scales: { 'yAxes': [{ stacked: false, label: yLabels[type], id: 'A', position: 'left' }], 'xAxes': { stacked: false, label: '' } },
            type: 'line'
        }
    },

    'contracts': (data) => {
        let returnData = []
        for (let item in data) {
            if (item.includes('Hours')) {
                let obj = {}
                obj.label = item
                obj.data = data[item]
                obj.fill = false
                obj.radius = 2
                obj.type = item === 'Hours Contract' ? 'bar' : 'line'
                returnData.push(obj)
            }
        }

        return {
            labels: Array.from(new Set(data.x_label)),
            data: returnData,
            scales: { 'yAxes': [{ stacked: false, label: 'Hourly rate (€)', id: 'A', position: 'left' }], 'xAxes': { stacked: false, label: '' } },
            type: 'bar'
        }
    },

    'contracts_employee': (data) => {
        let dataDict = {}
        let uniqueXlabels = Array.from(new Set(data['x_label']))
        let uniqueFunctions = Array.from(new Set(data['Employee Function']))

        for (let func of uniqueFunctions) {
            dataDict[func] = new Array(uniqueXlabels.length).fill(0)
        }

        for (let i in uniqueXlabels) {
            var indexes = getAllIndexes(data['x_label'], uniqueXlabels[i])
            for (let idx of indexes) {
                dataDict[data['Employee Function'][idx]][i] = data['Hours contract'][idx]
            }
        }

        let returnData = []
        for (let item in dataDict) {
            let obj = {}
            obj.label = item
            obj.data = dataDict[item]
            obj.yAxisID = 'A'
            obj.type = 'bar'
            returnData.push(obj)
        }

        return {
            labels: Array.from(new Set(data['x_label'])),
            data: returnData,
            scales: { 'yAxes': [{ stacked: true, label: 'Hours', id: 'A', position: 'left' }], 'xAxes': { stacked: true, label: '' } },
            type: 'bar'
        }
    },
    'budgetsummary': (data) => {
        let returnData = []
        let budgetOpen = data.open_budgets
        for (let item in data) {
            if (item.includes('hours') || item.includes('revenue')) {
                let obj = {}
                obj.label = item
                obj.data = data[item]
                for (let val in obj.data) {
                    if (obj.data[val] === 0) {
                        obj.data[val] = null
                    }
                }
                obj.fill = false
                obj.radius = 2

                if (item === 'Budget hours') {
                    obj.backgroundColor = [
                        'rgba(255,224,137,0.3)',
                        'rgba(255,224,137,0.3)',
                        'rgba(255,224,137,0.3)',
                        'rgba(255,224,137,0.3)',
                        'rgba(255,224,137,0.3)',
                        'rgba(255,224,137,0.3)',
                        'rgba(96,152,147,0.3)',
                        'rgba(255,224,137,0.3)',
                        'rgba(255,224,137,0.3)',
                        'rgba(255,224,137,0.3)',
                        'rgba(255,224,137,0.3)',
                        'rgba(255,224,137,0.3)',
                        'rgba(255,224,137,0.3)',
                        'rgba(255,224,137,0.3)'
                    ]
                    obj.borderColor = [
                        'rgba(255,224,137,1)',
                        'rgba(255,224,137,1)',
                        'rgba(255,224,137,1)',
                        'rgba(255,224,137,1)',
                        'rgba(255,224,137,1)',
                        'rgba(255,224,137,1)',
                        'rgba(96,152,147,1)',
                        'rgba(255,224,137,1)',
                        'rgba(255,224,137,1)',
                        'rgba(255,224,137,1)',
                        'rgba(255,224,137,1)',
                        'rgba(255,224,137,1)',
                        'rgba(255,224,137,1)'
                    ]

                    for (let idx in obj.backgroundColor) {
                        if (budgetOpen[idx] === 'true' && parseInt(idx) !== 6) {
                            obj.backgroundColor[idx] = 'rgba(192,229,226,0.3)'
                            obj.borderColor[idx] = 'rgba(192,229,226,1)'
                        }
                    }
                }

                obj.type = item === 'Budget hours' ? 'bar' : 'line'
                obj.yAxisID = item === 'Budget hours' ? 'B' : 'A'
                obj.borderDash = item === 'Predicted revenue' ? [2, 5] : [0, 0]
                returnData.push(obj)
            }
        }

        return {
            labels: Array.from(new Set(data.x_label)),
            data: returnData,
            scales: { 'yAxes': [{ stacked: false, label: 'Revenue (€)', id: 'A', position: 'left' }, { stacked: false, label: 'Hours', id: 'B', position: 'right' }], 'xAxes': { stacked: false, label: '' } },
            type: 'bar',
            lineToday: true
        }
    },
    'dayHours': (data, weekDay, powerHoursType) => {
        let returnData = []
        let hoursRounded = []
        let averageHours = []
        let commercialShare = []
        let labels = []
        let activityRounded = []
        for (let idx in data['hour']) {
            if (data['weekday'][idx] === weekDay) {
                labels.push(data['hour'][idx])
                hoursRounded.push(data['hours_rounded'][idx])
                averageHours.push(data['employees_l6m'][idx])
                commercialShare.push(data['commercial_share'][idx])
                activityRounded.push(data['activity_rounded'][idx])
            }
        }

        var obj = {}
        obj.label = 'Commercial share'
        obj.data = commercialShare
        obj.type = 'line'
        obj.fill = false
        obj.radius = 2
        obj.yAxisID = 'B'
        returnData.push(obj)
        if (powerHoursType !== 'Week') {
            obj = {}
            obj.label = 'Average hours'
            obj.data = averageHours
            obj.type = 'line'
            obj.fill = false
            obj.radius = 2
            obj.yAxisID = 'A'
            returnData.push(obj)
        }
        obj = {}
        obj.label = 'Hours rounded'
        obj.data = hoursRounded
        obj.type = 'bar'
        obj.yAxisID = 'A'
        returnData.push(obj)
        obj = {}
        obj.label = 'Activity rounded'
        obj.data = activityRounded
        obj.type = 'bar'
        obj.yAxisID = 'A'
        obj.backgroundColor = '#D3D3D3'
        obj.borderColor = '#D3D3D3'
        returnData.push(obj)

        return {
            labels: labels,
            data: returnData,
            scales: { 'yAxes': [{ stacked: true, label: 'Hours', id: 'A', position: 'left' }, { stacked: false, label: 'Percentage', id: 'B', position: 'right' }], 'xAxes': { stacked: true, label: '' } },
            type: 'bar'
        }
    },
    'historic-tasks': (data) => {
        let xLabels = []
        let ticketsHandled = []
        let ticketsUnhandled = []

        for (let item of data) {
            xLabels.push(item['x_label'])
            ticketsHandled.push(item['tickets_handled'])
            ticketsUnhandled.push(item['tickets_unhandled'])
        }

        let returnData = []
        let obj = {}
        obj.label = 'Handled'
        obj.data = ticketsHandled
        obj.type = 'bar'
        obj.yAxisID = 'A'
        returnData.push(obj)
        obj = {}
        obj.label = 'Unhandled'
        obj.data = ticketsUnhandled
        obj.type = 'bar'
        obj.yAxisID = 'A'
        returnData.push(obj)

        return {
            labels: xLabels,
            data: returnData,
            scales: { 'yAxes': [{ stacked: true, label: 'Tickets', id: 'A', position: 'left' }], 'xAxes': { stacked: true, label: '' } },
            type: 'bar'
        }
    },
    'powerhoursweekdaygraph': (data, day) => {
        data = data.data
        // Group data by day
        let relevantData = []
        for (let item of data) {
            if (item.weekday === day) {
                relevantData.push(item)
            }
        }
        let labels = relevantData.map(x => x.from_time)
        let bar1 = relevantData.map(x => x.hours_advice)
        let bar2 = relevantData.map(x => x.hours_actual) // Outer bar
        let line1 = relevantData.map(x => x.commercial_share)
        let line2 = relevantData.map(x => x.traffic_share)

        let fill = []
        for (let i = 0; i < line1.length; i++) {
            if (line2[i] > line1[i]) {
                fill.push(line2[i])
                // line2[i] = null
            } else {
                fill.push(line1[i])
            }
        }
        var options = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                labels: {
                    filter: function (item, chart) {
                        // Logic to remove a particular legend item goes here
                        return !item.text.includes('Fill')
                    }
                }
            },
            scales: {
                xAxes: [{
                    stacked: true,
                    id: 'bar-x-axis1',
                    // barThickness: 40,
                    scaleLabel: {
                        display: true,
                        labelString: 'Time of day (h)',
                        fontSize: 14
                    }
                }, {
                    display: false,
                    stacked: true,
                    id: 'bar-x-axis2',
                    label: 'Test',
                    // barThickness: 40,
                    // these are needed because the bar controller defaults set only the first x axis properties
                    type: 'category',
                    // categoryPercentage: 0.8,
                    // barPercentage: 0.9,
                    gridLines: {
                        offsetGridLines: true
                    },
                    offset: true
                }],
                yAxes: [{
                    stacked: false,
                    ticks: {
                        max: relevantData[0].y_axis_1_max,
                        min: relevantData[1].y_axis_1_min
                    },
                    id: 'y-axis1',
                    scaleLabel: {
                        display: true,
                        labelString: 'Hours',
                        fontSize: 14
                    }
                },
                {
                    stacked: false,
                    ticks: {
                        max: relevantData[0].y_axis_2_max,
                        min: relevantData[1].y_axis_2_min
                    },
                    id: 'y-axis2',
                    position: 'right',
                    scaleLabel: {
                        display: true,
                        labelString: 'Share',
                        fontSize: 14
                    }
                }
                ]

            }
        }
        let chartData = {
            labels: labels,
            datasets: [
                {
                    label: 'Hours advice',
                    backgroundColor: 'rgba(255, 224, 137, 0.5)',
                    borderWidth: 2,
                    data: bar1,
                    xAxisID: 'bar-x-axis1',
                    stack: 'background',
                    yAxisID: 'y-axis1'
                },
                {
                    label: 'Hours actual',
                    borderColor: 'rgba(0, 0, 0, 0.5)',
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                    borderWidth: 2,
                    borderDash: [2, 5],
                    data: bar2,
                    xAxisID: 'bar-x-axis2',
                    yAxisID: 'y-axis1'
                },
                {
                    label: 'Commercial share',
                    borderColor: '#80CBC4',
                    backgroundColor: '#80CBC4',
                    borderWidth: 3,
                    borderDash: [2, 5],
                    data: line1,
                    type: 'line',
                    yAxisID: 'y-axis2',
                    fill: false
                },
                {
                    label: 'Fill',
                    backgroundColor: 'rgba(255,154,154,0.5)',
                    borderWidth: 0,
                    data: fill,
                    type: 'line',
                    yAxisID: 'y-axis2',
                    fill: '-1'
                },
                {
                    label: 'Traffic share',
                    borderColor: 'rgba(144, 202, 249, 1)',
                    backgroundColor: 'rgba(144, 202, 249, 0.5)',
                    borderWidth: 3,
                    data: line2,
                    fill: false,
                    type: 'line',
                    yAxisID: 'y-axis2'
                }

            ]
        }

        return [chartData, options]
    }

}
